<template>
    <vue-dropzone ref="myVueDropzone" id="dropzone" :useCustomSlot=true :options="dropzoneOptions" v-on:vdropzone-removed-file="removedFile" v-on:vdropzone-success="success" v-on:vdropzone-error="failed" v-on:vdropzone-sending="sendingEvent" v-on:vdropzone-max-files-exceeded="exceeded">
        <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">Subir {{ document.description }}</h3>
      </div>
    </vue-dropzone>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {

    props: {
        document: {
            type: Object,
            required: true
        },
        ruap_id: {
            type: Number,
            required: true
        }
    },

    components: {
        vueDropzone: vue2Dropzone
    },

    data () {
        return {
            dropzoneOptions: {
                timeout: 1800000,
                url: '/api/cliente/ap-revision',
                thumbnailWidth: 100, // px
                thumbnailHeight: 100,
                maxFiles: 1,
                acceptedFiles: 'application/pdf',
                addRemoveLinks: true,
                dictRemoveFile: "Limpiar"
            }
        }
    },

    methods: {

        failed(file, message, xhr) {
            let response = xhr.response;
            console.log(response)
            let parse = JSON.parse(response, (key, value)=>{
                return value;
            });
        },

        sendingEvent (file, xhr, formData) {
            xhr.ontimeout = function (e) {
                console.log(e, "Argh I timed out")
            };
            formData.append(`ruap_id`, this.ruap_id);
            formData.append(`document_id`, this.document.id);
        },

        exceeded(file) {
            this.$refs.myVueDropzone.removeFile(file)
        },

        success(file,response){
            this.$emit('responseSuccess',response)
            this.$refs.myVueDropzone.disable()
        },

        removedFile(file, error, xhr){
            this.$refs.myVueDropzone.enable()
        }
    }

}
</script>
<style scoped>
    .dropzone .dz-preview .dz-details {
      z-index: 1;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      font-size: 13px;
      min-width: 100%;
      max-width: 100%;
      padding: 2em 1em;
      text-align: center;
      color: rgba(0, 0, 0, 0.9);
      line-height: 150%; }

.dropzone .dz-preview .dz-image {
      border-radius: 20px;
      overflow: hidden;
      width: 120px;
      height: 120px;
      position: relative;
      display: block;
      z-index: 1; }
</style>





// WEBPACK FOOTER //
// resources/assets/js/components/DropZone.vue